<script>
import Spinner from '@components/spinner.vue'

export default {
  components: {
    Spinner,
  },
  created() {
    const { payload } = this.$route.query

    if (payload) {
      this.$store.dispatch('eShop/sendCredMobile', payload)
    }
  },
}
</script>

<template>
  <div class="container">
    <Spinner />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.container {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
